export default Object.freeze({
  TITLE: '할인쿠폰 관리',
  TAB_COUPON_LIST: '할인쿠폰 발행 관리',
  TAB_COUPON_ISSUE_LIST: '할인쿠폰 지급 관리',
  TOP_TBODY_MALL: '쇼핑몰',
  TOP_TBODY_MALL_ALL: '전체',
  TOP_TBODY_KEYWORD: '검색어',
  TOP_TBODY_KEYWORD_PLACEHOLDER: '검색어 입력',
  TOP_TBODY_DATE: '기간',
  TOP_TBODY_COUPON_ISSUE_STATUS: '지급설정 상태',

  TOP_TBODY_STATUS_ALL: '전체선택',
  TOP_TBODY_STATUS_ISSUE_READY: '지급대기',
  TOP_TBODY_STATUS_ISSUE_ING: '지급중',
  TOP_TBODY_STATUS_ISSUE_DONE: '지급완료',
  TOP_TBODY_STATUS_ISSUE_END: '지급종료',

  TOP_TBODY_ADD_COUPON_ISSUE: '할인쿠폰 지급등록',

  TOP_TBODY_SEARCH_TYPE_ALL: '전체',
  TOP_TBODY_SEARCH_TYPE_ISSUE_NO: '지급번호',
  TOP_TBODY_SEARCH_TYPE_REGISTRANT: '지급등록자',
  TOP_TBODY_SEARCH_TYPE_MODIFIER: '최종수정자',

  TOP_TBODY_DATE_TYPE_REGISTER: '등록일시',
  TOP_TBODY_DATE_TYPE_ISSUE: '발행일시',
  TOP_TBODY_DATE_TYPE_SCHEDULED: '예약일시',
  TOP_TBODY_DATE_TYPE_UPDATE: '최종수정일시',

  TOP_TBODY_SET_STATUS_ALL: '전체',
  TOP_TBODY_SET_STATUS_IMMEDIATELY: '즉시지급',
  TOP_TBODY_SET_STATUS_SCHEDULED: '예약지급',
  TOP_TBODY_SET_STATUS_PERIOD: '기간지급',

  FORM_HEADER_NO: '지급번호',
  FORM_HEADER_COPY: '복사',
  FORM_HEADER_MALLNAME: '쇼핑몰',
  FORM_HEADER_ISSUE_TIME_TYPE: '지급설정',
  FORM_HEADER_ISSUE_STATUS_TYPE: '지급상태',
  FORM_HEADER_MEMBER_GRADE: '회원등급',
  FORM_HEADER_MEMBER_GROUP: '회원그룹',
  FORM_HEADER_ISSUE_COUNT: '지급현황',
  FORM_HEADER_ISSUE_REASON: '지급사유',
  FORM_HEADER_REQUEST_YMDT: '예약일시',
  FORM_HEADER_ISSUE_YMDT: '지급일시',
  FORM_HEADER_REGISTER_ADMIN_NAME: '지급등록자',
  FORM_HEADER_REGISTER_YMDT: '등록일시',
  FORM_HEADER_UPDATE_ADMIN_NAME: '최종수정자',
  FORM_HEADER_UPDATE_YMDT: '최종수정일',
  FORM_HEADER_COPY_VALUE: '복사등록',

  FORM_HEADER_MALLNO: '쇼핑몰',
  FORM_PAYMENT_VALIDPERIOD_1: '지급일 기준',
  FORM_PAYMENT_VALIDPERIOD_2: '년',
  FORM_PAYMENT_VALIDPERIOD_3: '개월<br/>(',
  FORM_PAYMENT_VALIDPERIOD_4: '개월)',
  FORM_PAYMENT_VALIDPERIOD_5: '기본 유효기간에 따름',
  FORM_PAYMENT_VIEW_DETAIL_VIEW: '보기',
  FORM_PAYMENT_IMMEDIATELY_NOW: '즉시지급',
  FORM_PAYMENT_IMMEDIATELY_NOT: '예약지급',
  FORM_PAYMENT_REASON_TAG: '예약',
  FORM_HEADER_NO_NEXT_LINE_1: '적립금',
  FORM_HEADER_NO_NEXT_LINE_2: '번호',

  KEYWORD_IS_EMPTY: '검색어를 입력해주세요.',
  KEYWORD_ONLY_NUMBER: '숫자만 입력할 수 있습니다.',
  PERIOD_MAX_LIMIT: '조회기간은 최대 12개월까지 가능합니다.',
  CHECKBOX_MUST_SELECT: '지급상태값은 1개 이상 선택해야 합니다.',
  NO_DATA: '데이터가 존재하지 않습니다.'
});
